<template>
  <div class="current_keywords">
    <div class="content">
      <svg-vue
        style="width: 200px"
        icon="illustrations/review"
      />
      <h2>Want a quick review of your keywords?</h2>
      <p>In just a few minutes, our trained AI tool will review your chosen keywords based on your industry being:</p>

      <div v-if="user.active_website.industry">
        <span class="industry">{{ user.active_website.industry.category_name }}</span>
        <p class="mt-4 font-size-11 font-italic">
          Not correct?<br>You can change the category in your <a :href="`/website/settings/${user.active_website.hash_id}`">websites settings page</a>.
        </p>
      </div>

      <div 
        v-else 
        class="mt-3 message"
      >
        <InformationAlert 
          type="danger" 
          icon="icons/exclamation-circle"
        >
          <template #message>
            <strong>Warning:</strong> You need to select an industry to proceed.<br>
            <a :href="`/website/settings/${user.active_website.hash_id}`"> Click here</a> to select an industry.
          </template>
        </InformationAlert>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InformationAlert from '@/components/global/alerts/InformationAlert.vue';

export default {
  components: {
    InformationAlert,
  },
  computed: {
    ...mapGetters('user', [
      'user',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.message {
  a {
    color: #c91e2d;
    text-decoration: underline !important;
  }
}

.content {
  width: 500px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
  text-align: center;
  align-items: center;
  padding: 10px 0 55px;

  h2 {
    font-size: 32px;
    font-weight: 500;
    margin: 15px 0 0;
  }

  p {
    margin: 10px 0 0;
    font-size: 16px;
  }

  .industry {
    margin-top: 18px;
    background: #E4FAFD;
    font-size: 18px;
    font-weight: 500;
    padding: 8px 24px;
    border-radius: 100px;
  }
}
</style>
